import utils from "@/components/declarations/validators/utils";

export default {
  isValid(self, isDraft) {
    const errors = {
      atLeastOne: false,
      noneSelected: false,
    };
    self.setErrors(errors);

    if (!utils.solidFuelBoilersCount(self)) {
      return errors;
    }

    let text = "";

    const selectedCount = self.selectedFuelTypes.filter((el) => el.selected).length;
    if (!isDraft && !selectedCount) {
      errors.noneSelected = true;
      text += "Prosimy o zaznaczenie przynajmniej jednego rodzaju paliwa<br/>";
      errors.atLeastOne = true;
    }

    if (errors.atLeastOne) {
      utils.showMessage(self, text);
    }

    return errors;
  }
}
